import isEmpty from 'lodash/isEmpty';

const findAll = (root, selector) => [
  ...(root.matches?.(selector) ? [root] : []),
  ...(root.querySelectorAll?.(selector) || [])
];

export const setupCloseableMessages = (root = document) => {
  findAll(root, 'div.message .close')
    .filter(closeElement => !closeElement.hasAttribute('data-swf-message-close'))
    .forEach(closeElement => {
      closeElement.setAttribute('data-swf-message-close', 'true');
      $(closeElement).on('click', function () {
        $(this).closest('.ui.message').transition('fade');
      });
    });
};

export const messageBeforeElement = ({
                                       element,
                                       id,
                                       classNames = [],
                                       header,
                                       text,
                                       closeable = true,
                                       loader = false
                                     }) => {
  const messageElement = document.createElement('div');
  messageElement.id = id;
  messageElement.classList.add('ui', 'message', 'icon', 'transition', 'visible');
  classNames.forEach(className => messageElement.classList.add(className));

  if (closeable) {
    messageElement.insertAdjacentHTML('beforeend', '<i class="close icon"></i>');
  }

  if (loader) {
    messageElement.insertAdjacentHTML('beforeend', '<div class="ui active inline loader" style="margin-right: 1em"></div>');
  }

  messageElement.insertAdjacentHTML('beforeend', `<div class="content">
  ${isEmpty(header) ? '' : `<div class="header">${header}</div>`}
  ${text}
  </div>`);

  let existingMessageElement = document.getElementById(id);
  if (existingMessageElement) {
    existingMessageElement.replaceWith(messageElement);
  } else {
    element.insertAdjacentElement('beforebegin', messageElement);
  }

  setupCloseableMessages(messageElement);
};
